import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonPage, IonTitle, useIonViewWillEnter } from '@ionic/react';
import { arrowBack, checkmarkDoneOutline, bookOutline, cardOutline, checkmarkCircle, chevronDown, chevronForward, navigateOutline, printOutline, storefrontOutline, timeOutline } from 'ionicons/icons';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import CompletionScreen from '../../../../../components/Onboarding/CompletionScreen';
import ExitConfirmModal from '../../../../../components/Onboarding/ExitConfirmModal';
import { MessageContext } from '../../../../../contexts/MessageContext';
import { EtapaOnboarding, OnboardingContext } from '../../../../../contexts/OnboardingContext';
import { onboardingAtualizarEtapa, requestService } from '../../../../../Utils/Services';
import iconRobo from "./imgs/robo.svg";
import './OnboardingChecklist.css';

type GrupoConfig = { id: string; nome: string; };
type EtapaConfig = { id: string; nome: string; url: string; tempo: string; descricao: string; icone: string; };

const GRUPOS: GrupoConfig[] = [
    { id: 'configuracao_inicial', nome: 'Configuração Inicial' },
    { id: 'delivery', nome: 'Configuração de Delivery' },
    { id: 'configuracoes_gerais', nome: 'Configurações Gerais' },
];

const ETAPAS_CONFIG: EtapaConfig[] = [
    { id: 'dados_estabelecimento', nome: 'Dados do estabelecimento', url: '/empresa/contaalt', tempo: '3 min', descricao: 'Informe o nome, endereço e telefone do seu negócio.', icone: storefrontOutline },
    { id: 'horarios', nome: 'Horários de funcionamento', url: '/empresa/horarios', tempo: '3 min', descricao: 'Defina os dias e horários que sua loja aceita pedidos.', icone: timeOutline },
    { id: 'forma_pagamento', nome: 'Forma de pagamento', url: '/empresa/formapagamento', tempo: '6 min', descricao: 'Configure os pagamentos aceitos no balcão e no delivery.', icone: cardOutline },
    { id: 'catalogo', nome: 'Catálogo de produtos', url: '/empresa/produtoscatalogo', tempo: '15 min', descricao: 'Crie ou importe seu cardápio de produtos.', icone: bookOutline },
    { id: 'configuracao_entrega', nome: 'Configuração de entrega', url: '/empresa/configuracoesentrega', tempo: '6 min', descricao: 'Defina suas áreas de entrega e taxas.', icone: navigateOutline },
    { id: 'robozinho', nome: 'Ativação do Robozinho', url: '/empresa/integracoes', tempo: '4 min', descricao: 'Configure o robô para atender e confirmar pedidos automaticamente pelo WhatsApp.', icone: iconRobo },
    // { id: 'pix_automatizado', nome: 'Pix Automatizado', url: '/empresa/integracoes', tempo: '4 min', descricao: 'Receba pagamentos Pix instantâneos via Mercado Pago.', icone: iconPixAutomatizado },
    { id: 'impressao', nome: 'Impressão', url: '/empresa/impressao', tempo: '5 min', descricao: 'Configure sua impressora para imprimir pedidos automaticamente.', icone: printOutline },
];

const OnboardingChecklist: React.FC = () => {
    const history = useHistory();
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);
    const { nomeMenu, setNomeMenu } = useContext(MessageContext);
    const { loja } = useContext(MessageContext);
    const { onboardingData, setOnboardingData, setEtapaAtual } = useContext(OnboardingContext);

    const [expandedGroups, setExpandedGroups] = useState<Record<string, boolean>>({
        configuracao_inicial: true,
        delivery: true,
        configuracoes_gerais: true,
    });
    const [showExitModal, setShowExitModal] = useState(false);

    useIonViewWillEnter(() => {
        setEtapaAtual(null);
        setEsconderMenu(true);
        setNomeMenu("");

    });

    if (!onboardingData) {
        return (
            <IonPage>
                <IonContent className="onboarding-checklist-page">
                    <div style={{ padding: '40px', textAlign: 'center', color: '#6B7280' }}>Carregando...</div>
                </IonContent>
            </IonPage>
        );
    }

    if (onboardingData.onboarding_concluido) {
        const slug = loja || '';
        return (
            <IonPage>
                <IonContent className="onboarding-checklist-page">
                    <CompletionScreen isOpen={true} slug={slug} onGoHome={() => history.push('/empresa/inicio')} />
                </IonContent>
            </IonPage>
        );
    }

    const etapas = [...onboardingData.etapas].sort((a, b) => a.ordem - b.ordem);

    const toggleGroup = (grupoId: string) =>
        setExpandedGroups(prev => ({ ...prev, [grupoId]: !prev[grupoId] }));

    const handleClickEtapa = (etapa: EtapaOnboarding) => {
        const config = ETAPAS_CONFIG.find(e => e.id === etapa.id);
        if (!config) return;
        setEtapaAtual(etapa.id);
        if (etapa.status === 'pendente') {
            // const loja = localStorage.getItem('loja') || '';
            const url = onboardingAtualizarEtapa.url.replace('{empresa_id}', encodeURIComponent(loja));
            requestService(url, {
                method: onboardingAtualizarEtapa.method,
                body: JSON.stringify({ etapa_id: etapa.id, status: 'em_progresso', automatico: false }),
            }, history,
                (response: any) => { setOnboardingData(response); },
                (error: any) => { console.log('Erro ao atualizar etapa:', error); }
            );
        }
        history.push(config.url);
    };

    const renderEtapa = (etapa: EtapaOnboarding) => {
        const config = ETAPAS_CONFIG.find(e => e.id === etapa.id);
        if (!config) return null;
        return (
            <button type="button" key={etapa.id} className={`onboarding-step ${etapa.status}`} onClick={() => handleClickEtapa(etapa)}>
                <span className={`onboarding-step-icon ${etapa.status}`}>
                    <IonIcon icon={etapa.status === 'concluido' ? checkmarkCircle : config.icone} aria-hidden="true" />
                </span>
                <span className="onboarding-step-info">
                    <span className="onboarding-step-name"><strong>{config.nome}</strong></span>
                    <span className="onboarding-step-desc">{config.descricao}</span>
                    <span className="onboarding-step-meta">
                        {etapa.status === 'concluido'
                            ? <span className="onboarding-step-badge-done">Concluído</span>
                            : <><span className="onboarding-step-time"><IonIcon icon={timeOutline} aria-hidden="true" />{config.tempo}</span>{etapa.status === 'em_progresso' && <span className="onboarding-step-badge-progress">Em andamento</span>}</>}
                    </span>
                </span>
                <IonIcon icon={chevronForward} className="onboarding-step-arrow" aria-hidden="true" />
            </button>
        );
    };

    const renderGrupo = (grupo: GrupoConfig) => {
        const etapasDoGrupo = etapas.filter(e => e.grupo === grupo.id);
        const concluidasDoGrupo = etapasDoGrupo.filter(e => e.status === 'concluido').length;
        const totalDoGrupo = etapasDoGrupo.length;
        const expanded = expandedGroups[grupo.id];
        if (etapasDoGrupo.length === 0) return null;
        return (
            <section key={grupo.id} className="onboarding-group" aria-labelledby={`onboarding-grupo-${grupo.id}`}>
                <button type="button" className="onboarding-group-header" aria-expanded={expanded} aria-controls={`onboarding-etapas-${grupo.id}`} onClick={() => toggleGroup(grupo.id)}>
                    <span className="onboarding-group-header-left">
                        <strong id={`onboarding-grupo-${grupo.id}`} className="onboarding-group-title">{grupo.nome}</strong>
                        <span className="onboarding-group-count">{concluidasDoGrupo} de {totalDoGrupo} etapas concluídas</span>
                    </span>
                    {concluidasDoGrupo === totalDoGrupo && <span className="onboarding-group-badge-done">Concluído</span>}
                    <IonIcon icon={chevronDown} className={`onboarding-group-chevron ${expanded ? 'expanded' : ''}`} aria-hidden="true" />
                </button>
                <div className="onboarding-group-progress" aria-hidden="true">
                    {etapasDoGrupo.map(e => <span key={e.id} className={`onboarding-group-progress-segment ${e.status === 'concluido' ? 'filled' : ''}`} />)}
                </div>
                <div id={`onboarding-etapas-${grupo.id}`} className="onboarding-group-steps" hidden={!expanded}>{expanded && etapasDoGrupo.map(renderEtapa)}</div>
            </section>
        );
    };

    const concluidas = etapas.filter(etapa => etapa.status === 'concluido').length;

    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar color="primary">
                    <IonButtons slot="start">
                        <IonButton aria-label="Voltar" onClick={() => { setShowExitModal(true); }}><IonIcon slot="icon-only" icon={arrowBack} /></IonButton>
                    </IonButtons>
                    <IonTitle>Configuração inicial</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="onboarding-checklist-page">


                <div className="onboarding-checklist-body">
                    <div className="onboarding-checklist-overview">
                        <div className="onboarding-checklist-intro">
                            <span className="onboarding-checklist-eyebrow">PRIMEIROS PASSOS</span>
                            <h1>Configure sua loja</h1>
                            <p>Complete as etapas abaixo para começar a vender. Você pode continuar de onde parou.</p>
                        </div>
                        <aside className="onboarding-checklist-summary" aria-label="Seu progresso">
                            <div><span className="onboarding-summary-icon"><IonIcon icon={checkmarkDoneOutline} aria-hidden="true" /></span><span><strong>{concluidas} de {onboardingData.total_etapas} etapas</strong><span>concluídas</span></span><b>{onboardingData.porcentagem}%</b></div>
                            <progress value={onboardingData.porcentagem} max={100} aria-label="Progresso total da configuração" />
                        </aside>
                    </div>
                    {GRUPOS.map(renderGrupo)}
                </div>

                <ExitConfirmModal
                    isOpen={showExitModal}
                    onStay={() => setShowExitModal(false)}
                    onLeave={() => { setShowExitModal(false); history.push('/empresa/inicio'); }}
                />

            </IonContent>
        </IonPage>
    );
};

export default OnboardingChecklist;